module.exports = __webpack_public_path__ + "static/media/remove-dark.57a04170.svg";